export type ConflictField = 'email' | 'cellphone';

type ConflictValidationResult = {
  nextFieldErrors: Partial<Record<ConflictField, string>>;
  toastMessage: string;
};

const buildConflictMessages = (nextFieldErrors: Partial<Record<ConflictField, string>>) => {
  if (nextFieldErrors.email && nextFieldErrors.cellphone) {
    return 'E-mail e celular já estão em uso. Revise os campos destacados.';
  }

  if (nextFieldErrors.email) {
    return 'E-mail já está em uso. Revise o campo destacado.';
  }

  if (nextFieldErrors.cellphone) {
    return 'Celular já está em uso. Revise o campo destacado.';
  }

  return '';
};

export const getConflictValidation = (error: any): ConflictValidationResult | null => {
  const responseData = error?.response?.data;
  const conflicts = responseData?.errorDetails?.conflicts ?? responseData?.conflicts;

  if (error?.response?.status !== 409 || !conflicts) {
    return null;
  }

  const nextFieldErrors: Partial<Record<ConflictField, string>> = {};

  if (conflicts.email?.exists) {
    nextFieldErrors.email = 'E-mail já está em uso.';
  }

  if (conflicts.cellphone?.exists) {
    nextFieldErrors.cellphone = 'Celular já está em uso.';
  }

  const toastMessage = buildConflictMessages(nextFieldErrors);

  if (!toastMessage) {
    return null;
  }

  return { nextFieldErrors, toastMessage };
};

export const buildUnexpectedUserFormErrorMessage = (actionDescription: string) => {
  return `Não foi possível ${actionDescription} agora. Nossos engenheiros já foram avisados. Tente recarregar a página e tentar novamente.`;
};
